import './ThankyouStyles.css';

import React, { Component } from 'react'

class ThankyouImg extends Component {
  render() {
    return (
      <div className='thankyou'>
        <div className='heading'>
          <h1>{this.props.heading}</h1>
          <p>{this.props.text}</p>
        </div>
      </div>
    )
  }
}

export default ThankyouImg
